module.exports = __webpack_public_path__ + "img/compact.bfcf8b3c.png";